import styled from 'styled-components';

import {Device} from '../../../constants';

const FeatureTitleContainer = styled.div`
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  margin-top: 2em;
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  z-index: 3;
  position: relative;
  padding: 10px;

  @media screen and (max-width: 1140px) {
    width: auto;
    max-width: none;
    align-items: baseline;
  }

  @media screen and ${Device.mobileL} {
    display: flex;
  }
`;

export default FeatureTitleContainer;
